import { useState } from "react";
import ThankYou from "../ThankYou";
import { submitToWeb3Forms } from "@/lib/web3forms";

const REASONS = [
  "General question",
  "Confirm an appointment",
  "Verify a representative",
  "Report a concern",
  "Other",
];

export default function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await submitToWeb3Forms(e.currentTarget, {
        subject: "New contact message — MTS website",
        fromName: "MTS Website — Contact Form",
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <ThankYou
        testId="contact-thank-you"
        heading="Thank you — your message has been received."
        body="A team member will follow up during business hours (Mon–Fri, 9:00 AM – 5:00 PM)."
      />
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="contact-form">
      <input type="checkbox" name="botcheck" tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="c-name" className="field-label">Full name</label>
          <input id="c-name" name="name" type="text" required className="field-input" autoComplete="name" data-testid="contact-input-name" />
        </div>
        <div>
          <label htmlFor="c-phone" className="field-label">Phone</label>
          <input id="c-phone" name="phone" type="tel" required className="field-input" autoComplete="tel" data-testid="contact-input-phone" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="c-email" className="field-label">Email</label>
          <input id="c-email" name="email" type="email" required className="field-input" autoComplete="email" data-testid="contact-input-email" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="c-reason" className="field-label">Reason for contacting</label>
          <select id="c-reason" name="reason" className="field-select" defaultValue="" required data-testid="contact-input-reason">
            <option value="" disabled>Select a reason</option>
            {REASONS.map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </div>
      </div>

      <div>
        <label htmlFor="c-message" className="field-label">Message</label>
        <textarea id="c-message" name="message" className="field-textarea" required placeholder="How can we help?" data-testid="contact-input-message" />
      </div>

      {error && (
        <p className="text-sm text-red-600" role="alert" data-testid="contact-error">{error}</p>
      )}

      <button type="submit" className="btn-primary" disabled={submitting} data-testid="contact-submit">
        {submitting ? "Sending…" : "Send message"}
      </button>
    </form>
  );
}
